import { LineChartDataKey } from "../../../Charts/LineChart/LineChart.type";
import { UiColors } from "../../../../config/ui/colors";

export const PATENTS_FILED_AND_GRANTED_FOR_HOME_APPLIANCES_CHART_DATA_KEYS: Array<LineChartDataKey> = [
	{
		name: "filed",
		translation: "Patents filed with European Patents Office",
		color: UiColors.charts.secondary,
		showLabel: true,
	},
	{
		name: "granted",
		translation: "Patents granted by European Patents Office",
		color: UiColors.charts.primary,
		showLabel: true,
	},
];
